import React from 'react';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const Drawer: React.FC<Props> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-50 flex justify-end">
            <div className="flex-1" onClick={onClose} />
            <div className="w-full max-w-md bg-white h-full shadow-xl overflow-y-auto">
                {children}
            </div>
        </div>
    );
};

export default Drawer;
